// Prepends the customer's default order notes to the given notes
export function prependDefaultOrderNotes(defaultOrderNotes = '', notes = ''): string {
    return [defaultOrderNotes, notes].filter((value) => typeof value === 'string' && value.trim()).join(' ')
}

// Removes previously prepended default order notes, e.g. when the customer is changed
export function stripDefaultOrderNotes(defaultOrderNotes = '', notes = ''): string {
    if (!defaultOrderNotes) {
        return notes
    }

    if (notes === defaultOrderNotes) {
        return ''
    }

    if (notes.startsWith(`${defaultOrderNotes} `) || notes.startsWith(`${defaultOrderNotes}\n`)) {
        return notes.slice(defaultOrderNotes.length + 1)
    }

    return notes
}
